import { GraphQLClient } from 'graphql-request';

const host = 'https://graphql.contentful.com';
export const client = new GraphQLClient(
  `${host}/content/v1/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE}`,
  {
    headers: {
      authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_TOKEN}`,
    },
  },
);

export const previewClient = new GraphQLClient(
  `${host}/content/v1/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE}`,
  {
    headers: {
      authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN}`,
    },
  },
);
